{
    "USERID": "UserID",
    "DOCID": "Document ID",
    "ACCESSDATE": "Access Date",
    "ACCESSMETHOD": "Access Method",
    "NO_DATA_FOUND":"No data found.",
    "LOADMORE_TXT": "Load More..."
}